module.exports = __webpack_public_path__ + "img/Sala de niños.487815f5.png";